import type { LucideIcon } from "lucide-react";

export function AuthCardIcon({ icon: Icon }: { icon: LucideIcon }) {
    return (
        <div className="flex w-full items-center justify-center">
            <div className="from-muted to-background flex size-18 items-center justify-center rounded-full bg-linear-to-b sm:size-20">
                <div className="bg-background flex size-12 items-center justify-center rounded-full border sm:size-13">
                    <Icon className="text-muted-foreground size-6 sm:size-7" />
                </div>
            </div>
        </div>
    );
}
